import axios from 'axios';
import storage from '@deezer/next/shared/utils/storage';

import type {MyUser} from './types';
import {
	STARMANIA_ACTIVE_ARTIST_STORAGE_KEY,
	STARMANIA_AUTH_TOKEN_STORAGE_KEY,
	STARMANIA_USER_STORAGE_KEY,
} from '@constants/storageKeys';

export const onTokenUpdate = (token: string) => {
	if (token) {
		axios.defaults.headers.common.Authorization = `JWT ${token}`;
		storage.set(STARMANIA_AUTH_TOKEN_STORAGE_KEY, token);
		return;
	}

	delete axios.defaults.headers.common.Authorization;
	storage.remove(STARMANIA_AUTH_TOKEN_STORAGE_KEY);
};

export const persistUser = (user: MyUser | undefined) => {
	if (user) {
		storage.set(STARMANIA_USER_STORAGE_KEY, user);
		return;
	}

	storage.remove(STARMANIA_USER_STORAGE_KEY);
};

export const persistActiveArtist = (artistId: number | undefined) => {
	if (typeof artistId === 'number') {
		storage.set(STARMANIA_ACTIVE_ARTIST_STORAGE_KEY, artistId);
		return;
	}

	storage.remove(STARMANIA_ACTIVE_ARTIST_STORAGE_KEY);
};
